var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"curriculo-container"},[_c('b-img',{attrs:{"fluid":"","src":require('@/assets/curriculo/curriculo20212.png'),"alt":"Perfil image"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }